import React from "react";

const InventoryDesktop = React.lazy(() => import("./ui/InventoryHub"));

export const InventoryPage = () => {
  return <InventoryDesktop />;
};
